import { render, staticRenderFns } from "./DiscoveryDialogContainer.vue?vue&type=template&id=2c3926f4&scoped=true&"
import script from "./DiscoveryDialogContainer.vue?vue&type=script&lang=js&"
export * from "./DiscoveryDialogContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3926f4",
  null
  
)

export default component.exports